import { Flex, Icon } from '@podiumhq/design-system';

import { useNotificationContext } from 'contexts/NotificationContextProvider';
import useShouldScrollToElement from 'hooks/useShouldScrollToElement';

const Notification = ({ shouldScrollToError }) => {
  const { message, shouldDisplay } = useNotificationContext() || {};
  const scrollRef = useShouldScrollToElement(
    shouldScrollToError && shouldDisplay
  );

  return shouldDisplay ? (
    <Flex ref={scrollRef} {...notificationWrapperStyles}>
      <Icon boxSize={5} color="red.base" mr="8px" type="AlertCircle" />
      <span>{message}</span>
    </Flex>
  ) : null;
};

const notificationWrapperStyles = {
  alignContent: 'center',
  alignItems: 'center',
  backgroundColor: 'red.lightest',
  borderRadius: '16px',
  color: 'red.base',
  fill: 'red.base',
  fontSize: '17px',
  lineHeight: '150%',
  marginBottom: '24px',
  padding: '11px',
};

export default Notification;
